import {
  IFillDataWizardBuy,
  TKeyOfDataWizardBuy,
  TNumberKeysOfIFillDataWizardBuy,
  TStringKeysOfIFillDataWizardBuy,
} from "../..";
import SureSwapStepBuy_1 from "../sureSteps/swap/step_1";
import SureSwapStepBuy_2 from "../sureSteps/swap/step_2";
import SureSwapStepBuy_3 from "../sureSteps/swap/step_3";
import SureSwapStepBuy_4 from "../sureSteps/swap/step_4";
import SureSwapStepBuy_5 from "../sureSteps/swap/step_5";
import SureSwapStepBuy_6 from "../sureSteps/swap/step_6";
import SureSwapStepBuy_7 from "../sureSteps/swap/step_7";

const getShureSwapSteps = (
  data: IFillDataWizardBuy,
  dataFeatures: Partial<IFillDataWizardBuy>,
  dataFormEstimate: Partial<IFillDataWizardBuy>,
  handleChangeDataObject: (data: Partial<IFillDataWizardBuy>) => void,
  handleChangeDataNumber: (
      data: number | number[],
      key: TNumberKeysOfIFillDataWizardBuy
    ) => void,
  handleChangeDataString: (
    data: string,
    key: TStringKeysOfIFillDataWizardBuy
  ) => void,
  onReset: (key: TKeyOfDataWizardBuy[]) => void,
  disabledAndPrev: {
    isNextStep_estimate: boolean;
    isNextStep_dataFeatures: boolean;
    isNextStep_communicationType: boolean;
    isNextStep_timeIntervalTypeView: boolean;
    isNextStep_viewRealtorParticipation: boolean;
    isNextStep_timeIntervalTypeCommunication: boolean;
  }
) => {
  // если знает что хочет преобрести и соберается продавать квартиру
  const {
    isNextStep_estimate,
    isNextStep_dataFeatures,
    isNextStep_communicationType,
    isNextStep_timeIntervalTypeView,
    isNextStep_viewRealtorParticipation,
    isNextStep_timeIntervalTypeCommunication,
  } = disabledAndPrev;

  return [
    <SureSwapStepBuy_1
      onChangePrice={handleChangeDataNumber}
      onChange={handleChangeDataObject}
      isNextStepDisabled={isNextStep_estimate}
      onReset={onReset}
      dataFormEstimate={dataFormEstimate}
    />,
    <SureSwapStepBuy_2
      onChange={handleChangeDataObject}
      data={dataFeatures}
      isNextStepDisabled={isNextStep_dataFeatures}
      onReset={onReset}
    />,
    <SureSwapStepBuy_3
      onChange={handleChangeDataString}
      data={data.communicationType}
      isNextStepDisabled={isNextStep_communicationType}
      onReset={onReset}
    />,
    <SureSwapStepBuy_4
      onChange={handleChangeDataString}
      data={data.timeIntervalTypeCommunication}
      isNextStepDisabled={isNextStep_timeIntervalTypeCommunication}
      onReset={onReset}
    />,
    <SureSwapStepBuy_5
      onChange={handleChangeDataString}
      data={data.viewRealtorParticipation}
      isNextStepDisabled={isNextStep_viewRealtorParticipation}
      onReset={onReset}
    />,
    <SureSwapStepBuy_6
      onChange={handleChangeDataString}
      data={data.timeIntervalTypeView}
      isNextStepDisabled={isNextStep_timeIntervalTypeView}
      onReset={onReset}
    />,
    <SureSwapStepBuy_7 data={data} />,
  ];
};

export default getShureSwapSteps;
